/* eslint-disable no-param-reassign */

import * as THREE from 'three';
import isIe from '@/scripts/utils/detect-ie';

const createButton = buttonParams => $(`
    <div class="video-play video-play_small video-play_accent" data-role="video-modal-trigger" data-params='${buttonParams}'></div>
  `);

export const videos = {};

export const loadImages = (entries) => {
  const loader = new THREE.TextureLoader();
  const resolveTexture = (resolve, texture, image, hasButton, buttonParams) => {
    texture.minFilter = THREE.LinearFilter;
    resolve({ texture, image, $button: hasButton ? createButton(buttonParams) : null });
  };
  return entries.map(({
    src, type, hasButton, buttonParams,
  }, index) => new Promise((resolve) => {
    if (type === 'img') {
      loader.load(
        src,
        texture => resolveTexture(resolve, texture, texture.image, hasButton, buttonParams),
        undefined, // onProgress callback not supported from r84
        (err) => {
          resolve({ err });
        },
      );
    } else {
      let texture;
      const video = document.createElement('video');
      video.addEventListener('loadedmetadata', () => {
        texture.needsUpdate = true;
      });
      video.setAttribute('playsinline', true);
      video.setAttribute('webkit-playsinline', true);
      video.preload = 'metadata';
      video.src = src;
      video.muted = true;
      video.loop = true;

      if (isIe()) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d', { alpha: false });
        video.addEventListener('loadedmetadata', () => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
        });
        texture = new THREE.Texture(canvas);
        videos[index] = ({ ctx, video, texture });
      } else {
        texture = new THREE.VideoTexture(video);
      }

      resolveTexture(resolve, texture, video, hasButton, buttonParams);
    }
  }));
};

export const renderVideo = (item) => {
  const { video, ctx, texture } = item;
  if (video.readyState === video.HAVE_ENOUGH_DATA) {
    ctx.drawImage(video, 0, 0);
    texture.needsUpdate = true;
  }
};


export const playVideo = video => video.play && video.play();

export const stopVideo = video => video.pause && video.pause();

export const loadVideo = (video) => {
  if (video.readyState !== undefined && video.readyState !== video.HAVE_ENOUGH_DATA) {
    video.load();
    return new Promise((resolve) => {
      video.addEventListener('canplaythrough', () => {
        resolve();
      });
    });
  }

  return Promise.resolve();
};

export const getUvRate = (width, height) => {
  const aspect = width / height;

  return new THREE.Vector2(aspect, 1);
};



// WEBPACK FOOTER //
// ./scripts/elements/CoverSlider/helper.js